import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import CheckoutTitlePage from 'components/Checkout/CheckoutTitlePage/CheckoutTitlePage';
import LoginMetadata from 'components/Identification/Login/LoginMetadata';
import { default as LoginContainer } from 'components/Identification/Login/Login';
import PaBanner from 'components/Identification/PaBanner/PaBanner';
import Alert from 'components/Common/Alert/Alert';
import useCurrentCountry from 'hooks/useCurrentCountry';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { pushGtmEvent } from 'services/gtm/gtmEvents';
import { getRoutesUri } from 'services/generic';
import { GTM_PAGE_LOGIN } from 'settings/gtm/gtmPageView';

import styles from './page.module.scss';

export default function Login(): JSX.Element {
  const { t } = useTranslation(['checkout']);
  const { isUk } = useCurrentCountry();
  const { state } = useLocation();

  useGtmPageView(GTM_PAGE_LOGIN, '');

  return (
    <>
      <LoginMetadata />
      <CheckoutTitlePage
        title={t('MY_ACCOUNT_CHECKOUT_STEP')}
        goTo={getRoutesUri<string>('cart')}
        classes={{ container: styles.sectionTitle }}
        onClick={() =>
          pushGtmEvent({
            event: '_click_other',
            category: 'clic autre - checkout',
            element: 'retour au panier',
          })
        }
      />
      {state?.redirectResetPassword && (
        <div className={styles.alert}>
          <Alert
            severity="success"
            label={t('LABEL_SUCCESS_RESET_PASSWORD', { ns: 'loginPage' })}
          />
        </div>
      )}
      {state?.mandatoryLogInNewsletter && (
        <div className={styles.alert}>
          <Alert
            severity="warning"
            label={t('LABEL_WARNING_NEWSLETTER', { ns: 'loginPage' })}
          />
        </div>
      )}
      <LoginContainer
        pageType={'checkout'}
        classes={{
          container: styles.pageContainer,
          login: {
            container: styles.loginContainer,
            form: {
              container: styles.loginFormContainer,
              forgotCustomerNumberLink: {
                wrapper: styles.forgotCustomerNumberLinkWrapper,
              },
              forgotPasswordLink: {
                wrapper: styles.forgotPasswordLinkWrapper,
              },
            },
            requiredFieldsInfo: styles.requiredFieldsInfo,
          },
          newCustomer: { container: styles.newCustomer },
        }}
      />
      {isUk && <PaBanner />}
    </>
  );
}
